import { TextField, TextFieldProps } from "@mui/material";

// Pass className = "ecn-input" to override default styles
const EcnInput = (props: TextFieldProps) => {
  return <TextField {...props} />;
};

export default EcnInput;
